<template>
  <div id="app">
    <keep-alive :include="cachedViewNames">
      <router-view />
    </keep-alive>
    <LegalTermsModal
      :visible="legalModalVisible"
      :initial-tab="legalModalTab"
      @close="closeLegalTerms"
    />
    <HelpCenterModal
      :visible="helpCenterVisible"
      :initial-category="helpCenterCategory"
      @close="closeHelpCenter"
    />
    <AppDownloadModal
      :visible="appDownloadVisible"
      @close="appDownloadVisible = false"
    />
    <CustomerServiceWidget />
  </div>
</template>

<script>
import LegalTermsModal from '@/components/rebuild/LegalTermsModal.vue'
import HelpCenterModal from '@/components/rebuild/HelpCenterModal.vue'
import AppDownloadModal from '@/components/rebuild/AppDownloadModal.vue'
import CustomerServiceWidget from '@/components/rebuild/CustomerServiceWidget.vue'

export default {
  name: 'App',
  components: { LegalTermsModal, HelpCenterModal, AppDownloadModal, CustomerServiceWidget },
  data() {
    return {
      legalModalVisible: false,
      legalModalTab: 'terms',
      helpCenterVisible: false,
      helpCenterCategory: '',
      appDownloadVisible: false
    }
  },
  computed: {
    cachedViewNames() {
      const routeName = this.$route.name
      const shouldKeepPortal = [
        'user-portal',
        'strategy-detail',
        'transactionAgreement'
      ].includes(routeName)
      return shouldKeepPortal ? ['UserPortal'] : []
    }
  },
  watch: {
    '$route.fullPath'() {
      this.legalModalVisible = false
      this.helpCenterVisible = this.$route.name === 'help-center'
      this.appDownloadVisible = false
    }
  },
  created() {
    this.$root.$on('open-legal-terms', this.openLegalTerms)
    this.$root.$on('open-help-center', this.openHelpCenter)
    this.$root.$on('open-app-download', this.openAppDownload)
    if (this.$route.name === 'help-center') this.helpCenterVisible = true
  },
  beforeDestroy() {
    this.$root.$off('open-legal-terms', this.openLegalTerms)
    this.$root.$off('open-help-center', this.openHelpCenter)
    this.$root.$off('open-app-download', this.openAppDownload)
  },
  methods: {
    openLegalTerms(tab = 'terms') {
      this.legalModalTab = tab === 'privacy' ? 'privacy' : 'terms'
      this.legalModalVisible = true
    },
    closeLegalTerms() {
      this.legalModalVisible = false
      this.$root.$emit('mobile-account-child-closed')
    },
    openHelpCenter(category = '') {
      this.helpCenterCategory = category
      this.helpCenterVisible = true
    },
    closeHelpCenter() {
      this.helpCenterVisible = false
      this.$root.$emit('mobile-account-child-closed')
      if (this.$route.name === 'help-center') {
        const target = localStorage.getItem('token') ? '/app/overview' : '/'
        this.$router.replace(target)
      }
    },
    openAppDownload() {
      this.appDownloadVisible = true
    }
  }
}
</script>
